/*
 * Copyright (c) 2019  Apricot Courses, LLC. All Rights Reserved.
 */

export const isProd: boolean =
  process.env.NODE_ENV === "production" ? true : false;

type ProdInfoType = {
  Name: String;
  Target: String;
};

// const storageExist = typeof Storage !== "undefined";
// export const showUX =
//   (isProd && storageExist && sessionStorage.accessKey) || !isProd;

export const ProdInfo: ProdInfoType = { Name: "Apricad", Target: "Nurses" };

export type ColorType =
  | "primary"
  | "info"
  | "success"
  | "warning"
  | "danger"
  | "transparent"
  | "white"
  | "rose"
  | "dark";
